// extracted by mini-css-extract-plugin
module.exports = {"hidden":"resultTab_hidden__jl1Es","textEmphasis":"resultTab_textEmphasis__GArza","btnArea":"resultTab_btnArea__MHGPL","btn":"resultTab_btn__4siEe","on":"resultTab_on__3aH30"};